import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { LoginUserResponse } from '@/repositories/generated';
import { systemManager } from '@/types';

const response: LoginUserResponse = systemManager;

export const loginUser = http.get(
  createMockEndpoint('/login_user'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
